import { Component, OnInit, Input } from '@angular/core';
import { FilterService } from '../filter.service'
import { TagService } from '../tag.service'
import { Tag } from '../tag'

@Component({
  selector: 'app-tag-filter',
  templateUrl: './tag-filter.component.html',
  styleUrls: ['./tag-filter.component.css']
})
export class TagFilterComponent implements OnInit {
  @Input() tag: Tag
  @Input() isManual = false
  @Input() isNoTags = false
  @Input() isSource = false

  constructor(
    private fs: FilterService,
    private tags: TagService
  ) { }

  ngOnInit() {
    if (this.isManual) {
      this.tag = this.tags.manual
    }
    if (this.isNoTags) {
      this.tag = this.tags.noTags
    }
  }

  get label() {
    return this.tag.title
  }

  switch(event) {
    if (event.ctrlKey)
      this.fs.setExcludeTagFilter(this.tag)
    else
      this.fs.setTagFilter(this.tag)
  }

  get isSelected() {
    return this.fs.isSelectedTag(this.tag)
  }

  get isExcluded() {
    return this.fs.isExcludedTag(this.tag)
  }

  get isExported() {
    return this.tags.isExportedTag(this.tag)
  }

}



// WEBPACK FOOTER //
// ./src/app/tag-filter/tag-filter.component.ts